// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Polyfill for browsers without crypto.randomUUID
import { v4 as uuidv4 } from 'uuid';

/**
 * Polyfill crypto.randomUUID for browsers that lack it (e.g. older Safari,
 * non-secure contexts). Uses uuid v4 as the fallback implementation.
 */
const root =
	typeof globalThis !== 'undefined'
		? globalThis
		: typeof window !== 'undefined'
			? window
			: typeof self !== 'undefined'
				? self
				: undefined;

if (root) {
	const cryptoObj =
		root.crypto ||
		(root.crypto = {
			randomUUID: uuidv4,
		} as unknown as Crypto);

	if (typeof cryptoObj.randomUUID !== 'function') {
		cryptoObj.randomUUID = uuidv4;
	}
}
